import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuInput } from "../../components/neu/Neu";
import { FormPageShell } from "../../components/data/FormPageShell";
import { createSupplier } from "../../api/purchases";

const EMPTY = { legal_name: "", name_ar: "", code: "", trn: "", country: "IQ", currency: "IQD",
                payment_terms_days: 30, email: "", phone: "", iban: "", credit_limit: "0.00" };
const FIELDS = [["legal_name", "legalName"], ["name_ar", "nameAr"], ["code", "code"],
                ["trn", "trn"], ["currency", "currency"], ["payment_terms_days", "paymentTerms"],
                ["email", "email"], ["phone", "phone"], ["iban", "iban"],
                ["credit_limit", "creditLimit"]];

// نموذج إضافة مورّد بصفحة كاملة: حقول شبكية + شريط أفعال سفلي ثابت.
export const SupplierForm = ({ onDone, onCancel }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ ...EMPTY });
  const [busy, setBusy] = useState(false);
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const save = async () => {
    setBusy(true);
    try {
      await createSupplier({
        legal_name: form.legal_name,
        name_ar: form.name_ar || null,
        code: form.code || null,
        currency: form.currency || "IQD",
        credit_limit: form.credit_limit || "0.00",
        payment_terms_days: Number(form.payment_terms_days) || 30,
        email: form.email || null,
        phone: form.phone || null,
        tax: { trn: form.trn || null, country: form.country || "IQ" },
        bank: { iban: form.iban || null },
      });
      toast.success(t("purchases.supplierCreated"));
      onDone?.();
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code || t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <FormPageShell
      testid="supplier-form"
      title={t("purchases.newSupplier")}
      subtitle={t("purchases.tabs.suppliers")}
      onBack={onCancel}
      onCancel={onCancel}
      onSubmit={save}
      submitLabel={t("purchases.addSupplier")}
      busy={busy}
      disabled={form.legal_name.trim().length < 2}
    >
      <div className="grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([key, labelKey]) => (
          <label key={key} className="grid gap-1.5">
            <span className="text-[11px] font-bold text-muted-foreground">
              {t(`purchases.${labelKey}`)}
            </span>
            <NeuInput data-testid={`supplier-${key}`} value={form[key]} onChange={set(key)}
                      dir={["legal_name", "name_ar"].includes(key) ? undefined : "ltr"} />
          </label>
        ))}
      </div>
    </FormPageShell>
  );
};
